import { APIError } from '../errors/APIError';
import { useAPIQuery } from '../useAPIProvider';

export const useUser = (id?: string) => {
  return useAPIQuery(['getUser', id], async client => {
    if (!id) return null;

    const response = await client.users.getUser({ params: { id } });
    if (response.status !== 200) throw APIError.fromResponse(response);
    return response.body;
  });
};
